import React, { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useNavigate } from "react-router-dom";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { toast } from "react-hot-toast";
import { getVendorName } from "../../../utils/getVendorName";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { useFetchOrdersByIdMutation, useFetchOrdersByTypeMutation, useInsertOrdersMutation, useSudamaPointAllocationMutation } from "../../../features/tenant/Orders/ordersApi"; import { hasPermission } from "../../../utils/hasPermission";
import TenantSlugs from "../../../utils/TenantSlug";

const OrderUpload = () => {
  const navigate = useNavigate();
  const [myList, setMyList] = useState([])
  const [file, setFile] = useState();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [csvData, setCsvData] = useState(null)
  const [latitude, setLatitude] = useState("1");
  const [longitude, setLongitude] = useState("1");
  const [errorRows, setErrorRows] = useState([])
  const [errorUploadModal, setErrorUploadModal] = useState(false)
  const [orderLines, setOrderLines] = useState([])
  const [orderLinesModal, setOrderLinesModal] = useState(false)

  const [pointAllocationModal, setPointAllocationModal] = useState(false)
  const [paStartDate, setPaStartDate] = useState("")
  const [paEndDate, setPaEndDate] = useState("")
  const [paIsLifetime, setPaIsLifetime] = useState(false)

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.log(error.message);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  }, []);

  const [
    fetchOrders,
    {
      data: ordersData,
      isLoading: ordersIsLoading,
      isError: ordersIsError,
      error: ordersError,
    },
  ] = useFetchOrdersByTypeMutation();

  const [
    fetchOrdersCsv,
    {
      data: orderCsvData,
      isLoading: orderCsvLoading,
      isError: orderCsvIsError,
      error: orderCsvError,
    },
  ] = useFetchOrdersByTypeMutation();

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  function parseCSV(string) {
    const csvHeader = string
      .slice(0, string.indexOf("\n"))
      .replace(/\s/g, "")
      .split(",");

    const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);
    const array = csvRows
      .map((row) => {
        const values = [];
        let insideQuotes = false;
        let currentField = "";

        for (let char of row) {
          if (char === "," && !insideQuotes) {
            values.push(currentField.trim());
            currentField = "";
          } else if (char === '"') {
            insideQuotes = !insideQuotes;
          } else {
            currentField += char;
          }
        }

        values.push(currentField.trim());
        return values;
      })
      .filter((values) => values.length === csvHeader.length)
      .map((values) => {
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index].trim();
          return object;
        }, {});
        return obj;
      });

    // console.log("array", array);
    return array;
  }

  useEffect(() => {
    const hasViewPermission = hasPermission("orderUpload");

    if (!hasViewPermission) {
      navigate(`/genefied/${getVendorName()}/`);
    }

    fetchOrdersFunction();
  }, [limit, offset]);

  const fetchOrdersFunction = () => {
    fetchOrders({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      type: "transfer_point",
      limit: limit,
      offset: offset,
    });
  };

  const [
    bulkInsertOrders,
    {
      data: addOrdersData,
      isLoading: addOrdersLoading,
      error: addOrdersError,
    },
  ] = useInsertOrdersMutation();

  const [
    fetchOrderById,
    {
      data: orderDetailsData,
      isLoading: orderDetailsLoading,
      error: orderDetailsError,
    },
  ] = useFetchOrdersByIdMutation();

  const [
    sudamaPointAllocation,
    {
      data: pointAllocationData,
      isLoading: pointAllocationLoading,
      error: pointAllocationError,
    },
  ] = useSudamaPointAllocationMutation();

useEffect(() => {
  if (pointAllocationData) {
    toast.dismiss("point-allocation-loading");
    toast.success(pointAllocationData?.message || "Point Allocation Successful", {
      id: "point-allocation-success",
    });

    console.log("pointAllocationData", pointAllocationData)

    // ---- CSV DOWNLOAD START ----
    const data = pointAllocationData?.body || []; // adjust based on your API

    if (data.length) {
      const headers = Object.keys(data[0]);

      const csvRows = [
        headers.join(","), // header row
        ...data.map((row) =>
          headers.map((field) => `"${row[field] ?? ""}"`).join(",")
        ),
      ];

      const csvString = csvRows.join("\n");

      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "point-allocation.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setPointAllocationModal(false);
  }

  if (pointAllocationError) {
    toast.dismiss("point-allocation-loading");
    toast.error(pointAllocationError?.data?.message || "Point Allocation Failed", {
      id: "point-allocation-error",
    });
  }
}, [pointAllocationData, pointAllocationError]);

  const handlePointAllocation = () => {
    if (!paIsLifetime && (!paStartDate || !paEndDate)) {
      toast.error("Please select both start date and end date, or check Lifetime");
      return;
    }
    toast.loading("Fetching Point Allocation...", { id: "point-allocation-loading" });
    
    let bodyPayload = {};
    if (!paIsLifetime) {
      bodyPayload = {
        start_date: paStartDate,
        end_date: paEndDate,
      };
    }

    sudamaPointAllocation({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: bodyPayload,
    });
  };

  useEffect(() => {
    if (orderDetailsError) {
      toast.error(orderDetailsError?.data?.message)
    }
    if (orderDetailsData?.body?.orderLine.length > 0) {
      setOrderLines(orderDetailsData?.body?.orderLine)
      setOrderLinesModal(true)
    }
  }, [orderDetailsData, orderDetailsError])


  if (ordersIsLoading) {
    toast.dismiss();
  }

  useEffect(() => {
    if (ordersData && ordersData.body) {
      toast.dismiss();
      setMyList(ordersData.body.orders ? ordersData.body.orders : []);


    }
  }, [ordersData])

  useEffect(() => {
    if (addOrdersError) {
      toast.error(addOrdersError?.data?.message)
      if (addOrdersError.data.Error.errorRows.length > 0) { 
      setErrorRows(addOrdersError.data.Error.errorRows)
      setErrorUploadModal(true)
      }
    }
    if (addOrdersData) {
      console.log(addOrdersData)
      if (addOrdersData.body.errorRows.length > 0) {
        toast.success("Orders Partially Added");
        setErrorRows(addOrdersData.body.errorRows)
        setErrorUploadModal(true)
      } else {
        toast.success("Orders Added");
      }
      fetchOrdersFunction()
    }
  }, [addOrdersData, addOrdersError])


  useEffect(() => {
    if (orderCsvData && orderCsvData?.body?.orders) {
      let csvList = orderCsvData.body.orders.map(el => {
        const { voucher_date, created_at, ...rest } = el
        const date = new Date(voucher_date);
        if (isNaN(date)) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return { ...rest, voucher_date: `${year}-${month}-${day}` };
      })
      setCsvData(csvList);
    }

    if (orderCsvError) {
      setCsvData(null);
    }
  }, [orderCsvData, orderCsvError])

  const [showModal2, setShowModal2] = useState(false);

  const handleShowOrderLines = (data) => {
    fetchOrderById({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: data.id,
    })
  };

  const handleBulkUploadOrders = (data) => {
    if (
      window.confirm(`Confirm adding orders?`)
    ) {
      console.log(data)
      bulkInsertOrders({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: data,
      });
      setShowModal2(false);
    }
    return;
  };

  const handleOnSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const fileReader = new FileReader();
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        let datas = parseCSV(text);
        let payload = {
          "platform": "WEB",
          "lat": latitude,
          "log": longitude,
          "rows": datas
        }
        console.log(payload)
        handleBulkUploadOrders(payload);
      };
      fileReader.readAsText(file);
    }
  };
  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "90px",
      textAlign: "left",
    },
    {
      name: "Order No",
      cell: (row) => row.order_no,
      sortable: true,
      width: "300px",
    },
    {
      name: "Order Date",
      cell: (row) => {
        const date = new Date(row?.voucher_date);
        if (isNaN(date)) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Buyer Code",
      cell: (row) => row?.buyer_code,
      sortable: true,
      width: "100px",
    },
    {
      name: "Quantity",
      cell: (row) => row.qty,
      sortable: true,
      width: "100px",

    },
    {
      name: "amount",
      cell: (row) => row.purchase_amount,
      sortable: true,
      width: "100px",

    },
    {
      name: "points",
      cell: (row) => row.points,
      sortable: true,
      width: "100px",
    },
    {
      name: "Transfer Points",
      cell: (row) => row.transfer_points,
      sortable: true,
      width: "100px",
    },
    {
      name: "",
      cell: (row) => (
        <button
          className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
          onClick={() => handleShowOrderLines(row)}
        >
          View
        </button>
      ),
      sortable: true,
      minWidth: "100px",
    }
  ];

  const errorColumn = [
    {
      name: "Customer Code",
      cell: (row) => row.customerCode,
      sortable: true,
      width: "100px",
    },
    {
      name: "Customer Name",
      cell: (row) => row?.customerName,
      sortable: true,
      width: "100px",
    },
    {
      name: "Bill Type",
      cell: (row) => row.billType,
      sortable: true,
      width: "100px",

    },
    {
      name: "Invoice Number",
      cell: (row) => row.invoiceNumber,
      sortable: true,
      width: "100px",

    },
    {
      name: "Invoice Date",
      cell: (row) => row.invoiceDate,
      sortable: true,
      width: "100px",
    },
    {
      name: "SKU Code",
      cell: (row) => row.skuCode,
      sortable: true,
      width: "100px",
    },
    {
      name: "Quantity",
      cell: (row) => row.quantity,
      sortable: true,
      width: "100px",
    },
     {
      name: "Reason",
      cell: (row) => row.reason,
      sortable: false,
      width: "100px",
    }
  ];

  const orderDetailColumn = [
    {
      name: "Order No",
      cell: (row) => row.order_no,
      sortable: true,
      width: "300px",
    },
    {
      name: "Voucher No",
      cell: (row) => row?.voucher_no,
      sortable: true,
      width: "100px",
    },
    {
      name: "Voucher Date",
      cell: (row) => {
        const date = new Date(row?.voucher_date);
        if (isNaN(date)) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },
      sortable: true,
      width: "100px",

    },
    {
      name: "Product Code",
      cell: (row) => row.product_code,
      sortable: true,
      width: "100px",

    },
    {
      name: "Quantity",
      cell: (row) => row.qty,
      sortable: true,
      width: "100px",
    },
    {
      name: "Purchase Amount",
      cell: (row) => row.purchase_amount,
      sortable: true,
      width: "100px",
    }, {
      name: "Points",
      cell: (row) => row.points,
      sortable: true,
      width: "100px",
    }, {
      name: "Transfer Points",
      cell: (row) => row.transfer_points,
      sortable: true,
      width: "100px",
    }
  ];


  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };

  const fetchOrdersForCsvFunction = () => {
    fetchOrdersCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      type: "transfer_point",
      limit: null,
      offset: null,
    });
  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center ">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Order Upload
            <LinksComponent />
          </div>
          <div className="p-3">
            <div className="flex gap-2">

              <div>
                <CustomExport fetchData={fetchOrdersForCsvFunction} data={csvData} defaultColumnExport={[
                  "order_no",
                  "voucher_date",
                  "buyer_code",
                  "qty",
                  "purchase_amount",
                  "points",
                  "transfer_points"
                ]}
                  filename="orders_list"
                />
              </div>

              {
                JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.sudama && (
                  <button
                    className="btn btn-outline-success clear-both mb-2"
                    onClick={() => setPointAllocationModal(true)}
                  >
                    Order Upload Detailed
                  </button>
                )
              }

              <button
                className="btn btn-outline-primary clear-both   mb-2"
                onClick={() => {
                  setShowModal2(true);
                }}
              >
                Add Order Csv
              </button>
            </div>
            <div className="w-full bg-white shadow rounded-lg">
              {(ordersIsLoading || orderCsvLoading || addOrdersLoading || orderDetailsLoading) && <CircleLoaderComponent />}
              <DataTableComponent
                columns={columns}
                data={myList}
                loading={ordersIsLoading}
                totalRows={ordersData?.body?.totalOrder}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
              ></DataTableComponent>
            </div>
          </div>
        </div>

        {errorUploadModal && (
          <ModalComponent show={errorUploadModal} setShow={(action) => {
            if (!action) {
              setErrorRows([])
              setErrorUploadModal(false)
            }
          }} size="4xl">
            <div className="w-full p-4">
              <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                Error Rows
              </div>
              <DataTableComponent
                columns={errorColumn}
                data={errorRows}
                pagination={false}
              ></DataTableComponent>
            </div>
          </ModalComponent>
        )}

        {orderLinesModal && (
          <ModalComponent show={orderLinesModal} setShow={(action) => {
            console.log("mMO", action)
            if (!action) {
              setOrderLines([])
              setOrderLinesModal(false)
            }
          }} size="3xl">
            <div className="w-full p-4">
              <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                Order Details
              </div>
              <DataTableComponent
                columns={orderDetailColumn}
                data={orderLines}
                pagination={false}
              ></DataTableComponent>
            </div>
          </ModalComponent>
        )}

        {showModal2 && (
          <ModalComponent show={showModal2} setShow={setShowModal2} size="md">
            <div className="w-full p-4">
              {
                <div className="flex justify-center mt-3 mb-3">
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                    onClick={() =>
                      downloadSampleCSV([
                        {
                          name: "customerCode",
                        },
                        {
                          name: "customerName",
                        },
                        {
                          name: "billType"
                        },
                        {
                          name: "invoiceNumber",
                        },
                        {
                          name: "invoiceDate",
                          "label": "Invoice Date (YYYY-MM-DD)",
                        },
                        {
                          name: "skuCode",
                        },
                        {
                          name: "quantity",
                        },
                        ...(JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
                          TenantSlugs.sudama ? [{
                            name: "billToCode",
                          }] : [])
                      ])
                    }
                  >
                    Sample Csv Download
                  </button>
                </div>
              }
              <div className="w-full m-auto  justify-center ">
                <div className="flex items-center justify-center w-full">
                  <label
                    for="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                  >
                    <div className="flex flex-col items-center justify-center ">
                      <svg
                        aria-hidden="true"
                        className="w-20 h-20 mb-3 text-gray-400 mt-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          strokeLinejoin="round"
                          stroke-width="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        ></path>
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 text-center">
                        <span className="font-semibold">Choose CSV file</span>
                        <div>Click to upload or drag and drop</div>
                      </p>
                    </div>
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      onChange={handleOnChange}
                    />
                  </label>
                </div>
              </div>
              <div className="flex justify-center mt-3">
                <button
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  onClick={(e) => handleOnSubmit()}
                >
                  Add
                </button>
              </div>
            </div>
          </ModalComponent>
        )}

        {pointAllocationModal && (
          <ModalComponent show={pointAllocationModal} setShow={setPointAllocationModal} size="md">
            <div className="w-full p-4">
              <h2 className="text-lg font-bold mb-4 border-b pb-2">Order Upload Detailed</h2>
              <div className="mb-4 flex items-center">
                <input
                  type="checkbox"
                  id="lifetime-checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 shadow-sm"
                  checked={paIsLifetime}
                  onChange={(e) => setPaIsLifetime(e.target.checked)}
                />
                <label htmlFor="lifetime-checkbox" className="ml-2 text-sm font-medium text-gray-900">
                  Lifetime (Full History)
                </label>
              </div>
              
              {!paIsLifetime && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                    <input
                      type="date"
                      className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={paStartDate}
                      onChange={(e) => setPaStartDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                    <input
                      type="date"
                      className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={paEndDate}
                      onChange={(e) => setPaEndDate(e.target.value)}
                    />
                  </div>
                </div>
              )}
              
              <div className="flex justify-center mt-4">
                <button
                  type="button"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  onClick={handlePointAllocation}
                  disabled={pointAllocationLoading}
                >
                  {pointAllocationLoading ? "Processing..." : "Submit"}
                </button>
              </div>
            </div>
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default OrderUpload;
